// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1vl2a","name":"ConsentHeader_name__33SqJ","birthday":"ConsentHeader_birthday__2kQbH","skeleton":"ConsentHeader_skeleton__ZgV6c"};